import { Route, Routes } from 'react-router-dom';

import { BREAKPOINTS } from '@/constants/breakpoints';

import DemoBanner from './components/DemoBanner/DemoBanner';
import { MainLayout } from './components/MainLayout/MainLayout';
import NotFound from './components/NotFound/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import { SidebarDesktop } from './components/SidebarMenu';
import { TopHeader } from './components/TopHeader/TopHeader';
import { ViewAdvisorBanner } from './components/ViewAdvisorBanner/ViewAdvisorBanner';
import { ROUTE } from './constants/route';
import { useDemoContext } from './hooks/DemoContext';
import { useAuth } from './hooks/useAuth';
import { useDemoBlocker } from './hooks/useDemoBlocker';
import { useI18n } from './hooks/useI18n';
import useScreenSize from './hooks/useScreenSize';
import { useSessionExpiredLogout } from './hooks/useSessionExpiredLogout';
import { useTrackingInit } from './hooks/useTracking/useTrackingInit';
import DemoBlockedModal from './modals/DemoBlockedModal/DemoBlockedModal';
import Auth0Callback from './pages/Auth0Callback/Auth0Callback';
import { ErrorPage } from './pages/ErrorPage/ErrorPage';
import { Login } from './pages/Login/Login';
import { PartnerAccess } from './pages/PartnerAccess/PartnerAccess';
import { RedirectionMail } from './pages/RedirectionMail/RedirectionMail';
import { ReinitialisationMdp } from './pages/ReinitialisationMpd/reinitialisationMdp';
import { ResetPassword } from './pages/ResetPassword/ResetPassword';
import { ValidationModificationMdp } from './pages/ValidationMoficationMdp';
import VueConseiller from './pages/vueConseiller/VueConseiller';
import { useUserStore } from './store/useStore';

function App() {
  const { user } = useAuth();
  const advisorUser = useUserStore((state) => state.user);
  const { isDemo } = useDemoContext();
  const { i18nLoaded } = useI18n();
  const { windowWidth } = useScreenSize();

  useTrackingInit();
  useSessionExpiredLogout();
  const { isBlocked, resetBlock } = useDemoBlocker();

  if (!i18nLoaded) {
    return null;
  }

  return (
    <div className={`${windowWidth <= BREAKPOINTS.tablet ? 'App-mobile' : 'App'}${isDemo ? ' with-demo-banner' : ''}`}>
      {(!user || windowWidth <= BREAKPOINTS.tablet) && <TopHeader />}
      {advisorUser?.advisorView && <ViewAdvisorBanner />}
      {isDemo && <DemoBanner />}
      {isBlocked && <DemoBlockedModal onClose={resetBlock} />}

      <div className={`${user ? 'mainFlex' : 'mainBlock'}` + (isDemo ? ' mainWithDemo' : '')}>
        {user && windowWidth > BREAKPOINTS.tablet && <SidebarDesktop />}

        <Routes>
          <Route
            path="/"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path={ROUTE.ACCESPARTENAIRES}
            element={
              <PublicRoute>
                <PartnerAccess />
              </PublicRoute>
            }
          />
          <Route
            path={ROUTE.RESETPASSWORD}
            element={
              <PublicRoute>
                <ResetPassword />
              </PublicRoute>
            }
          />
          <Route
            path={ROUTE.REDIRECTIONMAIL}
            element={
              <PublicRoute>
                <RedirectionMail />
              </PublicRoute>
            }
          />
          <Route
            path={ROUTE.REINTIALISATIONMDP}
            element={
              <PublicRoute>
                <ReinitialisationMdp />
              </PublicRoute>
            }
          />
          <Route
            path={ROUTE.VALIDATIONMODIFICATIONMDP}
            element={
              <PublicRoute>
                <ValidationModificationMdp />
              </PublicRoute>
            }
          />
          <Route
            path={ROUTE.SSOCONSEILLER}
            element={
              <PublicRoute>
                <VueConseiller />
              </PublicRoute>
            }
          />
          <Route
            path={ROUTE.AUTH0CALLBACK}
            element={
              <PublicRoute>
                <Auth0Callback />
              </PublicRoute>
            }
          />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          />
          <Route path={ROUTE.ERREUR} element={<ErrorPage />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
